/**
 * @typedef {Object} State - Initial state
 * @property {Object|null} userData - User data
 * @property {string|null} refreshToken - Refresh token
 * @property {string|null} accessToken - Access token
 * @property {string|null}  - Login error
 * @property {string|null} error - Signup error
 */

import * as types from "../constants/authConstants";

/** @type {State} */
const initialState = {
  userData: null,
  site: null,
  isAdmin: false,
  isSuperAdmin: false,
  refreshToken: null,
  signup: null,
  accessToken: null,
  error: null,
};
/**
 * Reducer function for handling authentication actions.
 * @param {State} state - Current state.
 * @param {Object} action - Action dispatched.
 * @returns {State} - New state.
 */
const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    /** Handle signup CLEAR action */
    case types.SIGNUP_USER_CLEAR:
      return { ...state, signup: null };

    /** Handle signup SUCCESS action */
    case types.SIGNUP_USER_SUCCESS:
      return { ...state, signup: payload, error: null };

    /** Handle signup failure action */
    case types.SIGNUP_USER_FAIL:
      return { ...state, signup: null, error: payload };

    /** Handle login success action */
    case types.LOGIN_USER_SUCCESS:
      return {
        ...state,
        userData: payload ? payload.user : null,
        isAuthenticated: true,
        site: 
        // localSite ? localSite : payload?.site ? { label: payload.site.Name, value: payload.site.Site_ID } :
         null,
        isAdmin: payload ? ['admin', 'superadmin'].includes(String(payload.user?.Role || '').toLowerCase()) : null,
        isSuperAdmin: payload ? String(payload.user?.Role || '').toLowerCase() === 'superadmin' : null,
      };
    case types.SET_USER_SITE:
      return { ...state, site: payload ? payload : null };

    case types.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        userData: payload ? payload : null,
        site: 
        // localSite ? localSite : payload?.site ? { label: payload.site.Name, value: payload.site.Site_ID } :
         null,
        isAdmin: payload ? ['admin', 'superadmin'].includes(String(payload.Role || payload.user?.Role || '').toLowerCase()) : null,
        isSuperAdmin: payload ? String(payload.Role || payload.user?.Role || '').toLowerCase() === 'superadmin' : null,
      };
    case types.GET_CURRENT_USER_FAIL:
      return {
        userData: null,
        site: null,
        isAdmin: false,
        isSuperAdmin: false,
        refreshToken: null,
        signup: null,
        accessToken: null,
        error: null,
      };


    /** Handle login failure action */
    case types.LOGIN_USER_FAIL:
      return {
        ...state,
        error: payload ? payload : null,
      };

    /** Handle set access token action */
    case types.SET_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: payload ? payload : null,
      };

    /** Handle set refresh token action */
    case types.SET_REFRESH_TOKEN:
      return {
        ...state,
        refreshToken: payload ? payload : null,
      };

    /** Handle set user data action */
    case types.SET_USER_DATA:
      return {
        ...state,
        userData: payload ? payload : null,

      };

    /** Handle logout action */
    case types.LOGOUT:
      return {
        ...state,
        site: null,
        userData: null,
        isAdmin: false,
        isSuperAdmin: false,
        refreshToken: null,
        accessToken: null,
        error: null,
      };

    /** Handle refresh token success action */
    case types.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        accessToken: payload ? payload.accessToken : null,
        refreshToken: payload ? payload.refreshToken : null,
      };

    /** Handle refresh token failure action */
    case types.REFRESH_TOKEN_FAIL:
      return {
        ...state,
        userData: null,
        refreshToken: null,
        accessToken: null,
        error: [],

      };
    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    /** Default case */
    default:
      return state;
  }
};

export default authReducer;
